module.exports = __webpack_public_path__ + "img/5-1.45140e75.jpg";